import { Routes } from "@angular/router";
import { COMMON_GUARD_OPTIONS } from "@app/shared/auth/constants/permissions.constant";
import { IAuthGuardOptions } from "@app/shared/auth/interfaces/auth.interface";
import { StockExpirationSettingsRoutePaths } from "./stock-expiration-settings-route-path";
import { stockExpirationSettingsResolver } from "./resolvers/get-stock-expiration-settings.resolver";
import { AuthGuard } from "@app/shared/auth/guards/auth.guard";
import { ExpirationSettingsRoutePaths } from "@app/applications/settings/domains/expiration-settings/expiration-settings-route-path";

const authGuardOptions: IAuthGuardOptions = {
  permissions: [
    ...COMMON_GUARD_OPTIONS.STOCK_EXPIRATION_SETTINGS.VIEW.permissions,
    ...COMMON_GUARD_OPTIONS.STOCK_EXPIRATION_SETTINGS.SET.permissions,
  ],
  redirectTo: ExpirationSettingsRoutePaths.ROOT,
};

export const stockExpirationSettingsRoutes: Routes = [
  {
    path: StockExpirationSettingsRoutePaths.ROOT,
    loadComponent: () =>
      import("./pages/stock-expiration-settings/stock-expiration-settings.component").then(t => t.StockExpirationSettingsComponent),
    resolve: {
      stockExpirationSettings: stockExpirationSettingsResolver,
    },
    canActivate: [AuthGuard],
    data: { authGuardOptions },
  },
];
